import { Performer } from '../../core/performer'
import { HttpMethod } from '../../core/types'

export class GetNudgeOutcomes extends Performer<void, Array<{ id: number; value: string }>> {
  protected method = HttpMethod.GET
  protected url = '/nudge/outcomes'
}

export default new GetNudgeOutcomes().perform
